<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex lg5 md5>
        <v-alert
          :value="true"
          type="info"
          mb-5
        >
          Logstash
        </v-alert>
        <v-flex mb-5></v-flex>
        <b-table
          striped
          hover
          :items="logstash"
          dark
        ></b-table>
      </v-flex>
      <v-flex lg5 md5 offset-md1>
        <v-alert
          :value="true"
          type="info"
        >
          Elasticsearch
        </v-alert>
        <v-flex mb-5></v-flex>
        <b-table
          striped
          hover :items="elasticsearch"
          dark
        ></b-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  components: {
  },
  data () {
    return {
      logstash: [],
      elasticsearch: [],
      headers_ls: [
        {
          text: 'Name',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Replicas',
          align: 'center',
          value: 'replicas'
        },
        {
          text: 'Port1',
          align: 'center',
          value: 'port1'
        }
      ],
      headers_es: [
        {
          text: 'Name',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Replicas',
          align: 'center',
          value: 'replicas'
        },
        {
          text: 'Port1',
          align: 'center',
          value: 'port1'
        },
        {
          text: 'Port2',
          align: 'center',
          value: 'port2'
        }
      ]
    }
  },
  created () {
    this.getstatuslogstash()
    this.getstatuselasticsearch()
  },
  methods: {
    async getstatuslogstash () {
      await axios.get(apiUrl + '/api/status/getstatuslogstash').then(response => {
        this.logstash = response.data
        for (let i = 0; i < this.logstash.length; i++) {
          if (this.logstash[i].port1 !== undefined) {
            const replicas = (this.logstash[i].replicas).split('/')
            if (replicas[0] === replicas[1]) {
              this.logstash[i]._rowVariant = 'success'
            } else if (replicas[0] < replicas[1] && replicas[0] !== 0) {
              this.logstash[i]._rowVariant = 'warning'
            } else if (replicas[0] === 0) {
              this.logstash[i]._rowVariant = 'danger'
            }
            this.logstash[i].port1 = (this.logstash[i].port1).split('->')[0]
          }
        }
        // this.timeout_ls()
      }).catch(e => {
        console.log(e)
        alert(e.response.data.errmsg)
      })
    },
    async getstatuselasticsearch () {
      await axios.get(apiUrl + '/api/status/getstatuselasticsearch').then(response => {
        this.elasticsearch = response.data
        for (let i = 0; i < this.elasticsearch.length; i++) {
          if (this.elasticsearch[i].port1 !== undefined) {
            const replicas = (this.elasticsearch[i].replicas).split('/')
            if (replicas[0] === replicas[1]) {
              this.elasticsearch[i]._rowVariant = 'success'
            } else if (replicas[0] < replicas[1] && replicas[0] !== 0) {
              this.elasticsearch[i]._rowVariant = 'warning'
            } else if (replicas[0] === 0) {
              this.elasticsearch[i]._rowVariant = 'danger'
            }
            this.elasticsearch[i].port1 = (this.elasticsearch[i].port1).split('->')[0]
            this.elasticsearch[i].port2 = (this.elasticsearch[i].port2).split('->')[1]
          }
        }
        // this.timeout()
      }).catch(e => {
        console.log(e)
        alert(e.response.data.errmsg)
      })
    },
    timeout () {
      setTimeout(() => {
        this.getstatuselasticsearch()
      }, 60000)
    },
    timeout_ls () {
      setTimeout(() => {
        this.getstatuslogstash()
      }, 60000)
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/monitor.vue